export default __webpack_public_path__ + "static/media/upActive.1485cfb4.svg";